<template>
  <v-container class="margen_paginas pt-7" fluid>

    <v-card class="mb-n4" style="background-color: #E8EAF6;">
      <v-card-title class="pa-2 pl-4" style="background: #b0b0c0">
        <v-icon class="mr-3">mdi-database</v-icon>
        <span style="font-size: 20px; font-weight: 400">{{ $t ('Consola de SQL') }}</span>
      </v-card-title>

      <v-container fluid style="background: #dcdcd0; border-bottom: 1px solid #BBBBBB">
        <v-row>
          <!-- aparcamiento -->
          <v-col>
            Introduzca las sentencias SQL o comandos MySQL a ejecutar:
             <v-textarea
              name="sql"
              filled
              auto-grow
              hide-details
              v-model="sentenciasSQL"
              style="font-family: monospace; font-size: 14px"
              spellcheck="false"
            ></v-textarea>

          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col class="pt-0">
            <v-btn class="mt-2" @click="ejecutarSQL">
              Ejecutar
            </v-btn>
          </v-col>
          <v-col>
            Formato: <v-select v-model="formatoSalida" style="display: inline-block" class="ml-1 mt-n3" :items="[{value: 0, text: 'Texto tabulado'}, {value: 1, text: 'Tabla de texto'}, {value: 2, text: 'Vertical'}]" hide-details></v-select>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="resultado" fluid>
        <v-row class="py-1">
          <v-col cols="12">
            Resultado de la ejecución:
            <pre id="resultado" v-html="resultado" style="font-family: monospace; font-size: 12px; padding: 10px; background: #f5f5ff; overflow: auto;" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>

  </v-container>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      sentenciasSQL: 'select NOW(), VERSION();',
      formatoSalida: 1,
      resultado: ''
    }
  },
  methods: {
    ejecutarSQL() {
      let json_peticion = {
        sentenciasSQL: this.sentenciasSQL,
        formatoSalida: this.formatoSalida,
      }
      api.ejecutarSQL (json_peticion)
        .then ((resultado)=> {
          this.resultado = resultado.data;
        });
    }
  }

};
</script>

<style>
#resultado {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>